import { render, staticRenderFns } from "./AlertingPagerduty.vue?vue&type=template&id=52bead62&scoped=true"
import script from "./AlertingPagerduty.vue?vue&type=script&lang=js"
export * from "./AlertingPagerduty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bead62",
  null
  
)

export default component.exports